<div class="quotes-preview-container">
  <!-- Loading state -->
  <div *ngIf="loading" class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <!-- Quote content -->
  <div *ngIf="!loading && record">
    <!-- Header -->
    <div class="flex justify-content-between align-items-center mb-4">
      <div>
        <span class="text-2xl font-bold">Devis {{ record?.invoice_ref || record?.invoice_number || record?.id }}</span>
        <p-tag 
          *ngIf="estAccepte"
          [value]="'Devis accepté'" 
          [ngClass]="'bg-green-200 text-green-800'"
          [icon]="'fa-light fa-check'"
          size="small"
          class="ml-2">
        </p-tag>
      </div>
      <div class="flex gap-2 flex-wrap">
        <p-button 
          size="small"
          icon="fa-light fa-download" 
          label="Télécharger PDF" 
          severity="secondary"
          [outlined]="true"
          (click)="downloadPDF()"
          [disabled]="processing || !pdfUrlRaw">
        </p-button>
        <p-button 
          *ngIf="canAccept"
          size="small"
          icon="fa-light fa-check" 
          label="Accepter" 
          severity="success"
          (click)="acceptQuote()"
          [loading]="processing"
          [disabled]="processing">
        </p-button>
        <p-button 
          *ngIf="canDecline"
          size="small"
          icon="fa-light fa-times" 
          label="Refuser" 
          severity="danger"
          (click)="rejectQuote()"
          [loading]="processing"
          [disabled]="processing">
        </p-button>
      </div>
    </div>
    
    <!-- PDF Viewer -->
    <div class="pdf-viewer-container" *ngIf="pdfUrlRaw">
      <div *ngIf="loadingPdf" class="flex justify-content-center align-items-center" style="height: 600px;">
        <div class="text-center">
          <p-progressSpinner></p-progressSpinner>
          <p class="mt-3 text-muted">Chargement du PDF...</p>
        </div>
      </div>
      <pdf-viewer 
        *ngIf="pdfBlobUrl && !loadingPdf"
        [src]="pdfBlobUrl"
        [render-text]="true"
        [original-size]="false"
        [show-all]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        style="display: block; width: 100%; height: calc(100vh - 300px); min-height: 600px;">
      </pdf-viewer>
    </div>

    <!-- Empty state -->
    <div *ngIf="!pdfUrlRaw" class="pdf-empty-state">
      <div class="empty-state-content">
        <i class="fa-light fa-file-pdf"></i>
        <h3>PDF non disponible</h3>
        <p>Le fichier PDF n'est pas disponible pour ce devis.</p>
      </div>
    </div>

    <!-- Action buttons (sticky at bottom on mobile) -->
    <div class="sticky-actions flex justify-content-center gap-2 p-4 bg-white border-top-1 border-gray-200 mt-4">
      <p-button 
        icon="fa-light fa-download" 
        label="Télécharger PDF" 
        severity="secondary"
        [outlined]="true"
        (click)="downloadPDF()"
        [disabled]="processing || !pdfUrlRaw">
      </p-button>
      <p-button 
        *ngIf="canAccept"
        icon="fa-light fa-check" 
        label="Accepter le devis" 
        severity="success"
        (click)="acceptQuote()"
        [loading]="processing"
        [disabled]="processing">
      </p-button>
      <p-button 
        *ngIf="canDecline"
        icon="fa-light fa-times" 
        label="Refuser le devis" 
        severity="danger"
        (click)="rejectQuote()"
        [loading]="processing"
        [disabled]="processing">
      </p-button>
    </div>
  </div>

  <!-- Error state -->
  <div *ngIf="!loading && !record" class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <div class="text-center">
      <i class="fa-light fa-exclamation-triangle text-6xl text-red-500 mb-3"></i>
      <h3>Devis introuvable</h3>
      <p class="text-muted">Le devis demandé n'existe pas ou n'est plus disponible.</p>
    </div>
  </div>
</div>

